import React from "react";

const InfoLibrary = [
  {
    title: "Information",
    id: "101",
  },
  {
    title: "Root Cause Information",
    id: "RC101",
  },
  {
    title: "Alarm Column Chart Information",
    id: "A201",
    }, {
        title: "Alarm Grid Information",
        id: "A202",
    },
  {
    title: "Device Information",
    id: "D101",
    }, {
        title: "Trigger Grid Information",
        id: "T101",
    }, {
        title: "Trigger Chart Information",
        id: "T102",
    }, {
        title: "Timeline Information",
        id: "TL101",
    },
    {
        title: "Machine Times Chart Information",
        id: "MT101",
    },
    {
        title: "General Filters Selection Information",
        id: "0",
    },
];

export default InfoLibrary;